import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

/**
 * The asset the feed's detail drawer is currently showing, if any.
 *
 * The feed's own route stays on the node whose news list is open — reading the news is not
 * navigation, so the tree must not move while the user is in the feed. But the selection still has
 * to survive the jump to an asset-level module: switching to Analysis or either overview with an
 * asset notification open lands on THAT asset instead of the listed node. `OptionNav` reads this to
 * pick the target node, so it lives in the store rather than in the feed's local state.
 *
 * Only assets are tracked: gateway and report notifications point at groups, and those
 * deliberately keep the tree's current height.
 */
export interface FeedSelectionState {
    assetNodeId: number | null;
}

const initialState: FeedSelectionState = { assetNodeId: null };

export const feedSelectionSlice = createSlice({
    name: 'feedSelection',
    initialState,
    reducers: {
        setFeedSelectedAsset: (state, action: PayloadAction<number | null>) => {
            state.assetNodeId = action.payload;
        },
    },
});

export const { setFeedSelectedAsset } = feedSelectionSlice.actions;

export const feedSelectionReducer = feedSelectionSlice.reducer;
